import './SankeyLabelOverlay.css';
export var dimmedLabel = '_1wbek5q8-3-15-1';
export var insideLabelPositioner = '_1wbek5q5-3-15-1';
export var insideZoneLabel = '_1wbek5q6-3-15-1';
export var insideZoneOverlay = '_1wbek5q4-3-15-1';
export var interactiveLabel = '_1wbek5q7-3-15-1';
export var leftZoneLabel = '_1wbek5q2-3-15-1';
export var rightZoneLabel = '_1wbek5q3-3-15-1';
export var sideLabelContainer = '_1wbek5q0-3-15-1';
export var sideLabelPositioner = '_1wbek5q1-3-15-1';